import { render, staticRenderFns } from "./AddSalaryPaymentModal.vue?vue&type=template&id=06ab69fa&scoped=true"
import script from "./AddSalaryPaymentModal.vue?vue&type=script&lang=js"
export * from "./AddSalaryPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./AddSalaryPaymentModal.vue?vue&type=style&index=0&id=06ab69fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ab69fa",
  null
  
)

export default component.exports